module.exports = __webpack_public_path__ + "static/media/life-ring.fccc6f5b.svg";